import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import Checkbox from '../../../Checkbox/Checkbox';

const CheckboxField: React.FC<BaseFieldProps> = props => (
	<BaseField name={props.name}>
		<Checkbox tx={props.label} />
	</BaseField>
);

export default CheckboxField;
